import React from 'react';
import { ReactSVG } from 'react-svg';
import closeIcon from 'assets/images/training/close-icon.svg';

import {
  Modal,
  Container,
  BtnContainer,
  Close,
  Button,
  BoxInfo,
} from './styles';

interface Item {
  area_code: string;
  cell_phone: string;
  email: string;
  hectares: string;
  name: any;
  pc: any;
}

interface Props {
  isOpen: boolean;
  onRequestClose(): void;
  producerInfo: Item;
}

const InfoProducer: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  producerInfo,
}) => {

  const formatCultureName = (key: string) => {
    const mapping: Record<string, string> = {
      Soja: 'Soja',
      milho: 'Milho',
      arroz_irrigado: 'Arroz Irrigado',
      feijao: 'Feijão',
      cana: 'Cana',
      algodao: 'Algodão',
      cafe: 'Café',
      citrus: 'Cítrus',
      batata: 'Batata',
      tomate: 'Tomate',
      cevada: 'Cevada',
      cenoura: 'Cenoura',
      mandioca: 'Mandioca',
      uva: 'Uva',
      melao: 'Melão',
      tabaco: 'Tabaco',
      trigo: 'Trigo',
      outras: 'Outras'
    };
  
    return mapping[key] || key;
  };
  

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <Close>
        <button type="button" onClick={onRequestClose}>
          <ReactSVG src={closeIcon} />
        </button>
      </Close>
      <Container>
        <BoxInfo>
          <div>
            <strong>Nome: </strong>
          </div>
          <div className="info">
            <p>{producerInfo.name}</p>
          </div>
        </BoxInfo>
        <BoxInfo>
          <div>
            <strong>Telefone:</strong>
          </div>
          <div className="info">
            <p>
              {'(' +
                producerInfo.area_code +
                ')' +
                ' ' +
                producerInfo.cell_phone}
            </p>
          </div>
        </BoxInfo>
        <BoxInfo>
          <div>
            <strong>E-mail: </strong>
          </div>
          <div className="info">
            <p>{producerInfo.email}</p>
          </div>
        </BoxInfo>
        <BoxInfo>
          <div>
            <strong>Hectares: </strong>
          </div>
          <div className="info">
            <p>{producerInfo.hectares}</p>
          </div>
        </BoxInfo>
        {producerInfo.pc && (
          <BoxInfo>
            <div>
              <strong>Culturas:</strong>
            </div>
            <div className="info">
              <p>
                {Object.entries(producerInfo.pc)
                  .filter(([_, value]) => value === '1')
                  .map(([key]) =>
                    key === 'outras_quais' ? null : formatCultureName(key),
                  )
                  .filter(Boolean)
                  .join(', ') || 'Nenhuma'}
              </p>
            </div>
          </BoxInfo>
        )}

        <BtnContainer>
          <Button type="button" buttonRole="primary" onClick={onRequestClose}>
            FECHAR
          </Button>
        </BtnContainer>
      </Container>
    </Modal>
  );
};

export default InfoProducer;
